module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-600.97e5b3c5.png";